import React from 'react';

// Inline vector copy of /public/logo-skull.svg — drawn as paths so it stays crisp at any size.
export default function LogoSkull({ className = '' }) {
  return (
    <svg className={className} viewBox="0 10 275 375" aria-hidden="true" focusable="false">
      <g id="skull" fill="#BAD2C4" transform="translate(0.000000,387.000000) scale(0.100000,-0.100000)">
    <path d="M1310 3606 c-225 -40 -420 -142 -576 -301 -77 -78 -98 -107 -143
-197 -69 -138 -91 -223 -98 -378 -9 -190 28 -345 119 -498 38 -64 183 -214
231 -238 18 -9 34 -20 37 -23 18 -25 150 -70 250 -87 135 -22 474 -14 501 13
7 7 15 68 20 145 10 156 25 236 48 262 40 46 102 57 164 31 52 -22 84 -61 113
-140 15 -38 34 -76 42 -82 9 -8 45 -13 87 -13 53 0 80 -5 110 -21 37 -20 59
-22 276 -27 130 -3 248 -2 263 2 24 6 26 10 26 64 0 104 -41 228 -103 316 -20
28 -20 30 -2 78 9 27 16 51 14 53 -33 39 -144 145 -149 143 -4 -2 -31 -32 -61
-67 -86 -102 -117 -122 -191 -128 -69 -6 -109 7 -156 51 -72 65 -87 223 -32
329 45 86 134 171 226 214 21 10 34 24 34 35 0 24 -65 120 -117 173 -146 149
-265 220 -468 277 -91 26 -355 34 -465 14z"/>
    <path d="M2355 3038 c-185 -96 -268 -308 -164 -417 68 -72 141 -50 237 72 83
106 82 100 36 246 -23 73 -48 121 -62 121 -4 -1 -25 -10 -47 -22z"/>
    <path d="M16093 2993 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
    <path d="M4567 2983 c9 -7 13 -79 16 -278 l3 -270 -1 274 c0 235 -2 275 -15
278 -11 3 -12 2 -3 -4z"/>
    <path d="M5470 2377 l5 -612 3 604 c1 333 -1 608 -5 612 -5 5 -6 -267 -3 -604z"/>
    <path d="M5870 2981 c0 -4 11 -6 25 -3 14 2 25 6 25 8 0 2 -11 4 -25 4 -14 0
-25 -4 -25 -9z"/>
    <path d="M8268 2984 c7 -3 12 -25 12 -54 0 -42 -3 -49 -22 -53 -20 -5 -20 -5
2 -4 23 2 25 5 25 56 0 40 -4 55 -15 58 -9 2 -10 1 -2 -3z"/>
    <path d="M8570 2983 c8 -3 26 -17 39 -31 13 -15 20 -20 16 -12 -15 29 -38 50
-54 49 -14 0 -14 -1 -1 -6z"/>
    <path d="M9646 2981 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z"/>
    <path d="M12045 2978 c-3 -7 -4 -283 -3 -613 l3 -600 3 607 c2 568 3 607 20
611 16 4 16 5 -1 6 -10 0 -20 -5 -22 -11z"/>
    <path d="M14165 2977 c-3 -7 -4 -127 -3 -267 l3 -255 5 268 c3 147 4 267 2
267 -1 0 -5 -6 -7 -13z"/>
    <path d="M14258 2983 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
    <path d="M14581 2987 c2 -1 13 -9 24 -17 19 -14 19 -14 6 3 -7 9 -18 17 -24
17 -6 0 -8 -1 -6 -3z"/>
    <path d="M15533 2983 c20 -5 20 -7 6 -36 -10 -21 -10 -21 5 -3 23 28 20 46 -6
45 -17 -1 -19 -2 -5 -6z"/>
    <path d="M16900 2986 c0 -2 9 -6 20 -9 11 -3 18 -1 14 4 -5 9 -34 13 -34 5z"/>
    <path d="M6700 2930 l0 -50 -312 -3 -313 -2 318 -3 317 -2 0 55 c0 30 -2 55
-5 55 -3 0 -5 -22 -5 -50z"/>
    <path d="M13275 2375 c0 -335 1 -471 2 -302 2 170 2 444 0 610 -1 166 -2 28
-2 -308z"/>
    <path d="M14490 2940 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M17610 2950 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
    <path d="M16380 2935 c14 -8 30 -14 35 -14 6 0 -1 6 -15 14 -14 8 -29 14 -35
14 -5 0 1 -6 15 -14z"/>
    <path d="M18144 2936 c11 -9 24 -16 30 -16 12 0 7 5 -24 19 -24 11 -24 11 -6
-3z"/>
    <path d="M10970 2916 c0 -3 14 -12 30 -21 17 -9 30 -13 30 -11 0 3 -13 12 -30
21 -16 9 -30 13 -30 11z"/>
    <path d="M18190 2916 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z"/>
    <path d="M12811 2907 c2 -1 15 -11 29 -22 l25 -20 -19 23 c-11 12 -24 22 -29
22 -6 0 -8 -1 -6 -3z"/>
    <path d="M15739 2873 l-34 -38 38 34 c34 33 42 41 34 41 -2 0 -19 -17 -38 -37z"/>
    <path d="M8650 2880 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M16466 2885 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z"/>
    <path d="M16068 2883 c17 -2 47 -2 65 0 17 2 3 4 -33 4 -36 0 -50 -2 -32 -4z"/>
    <path d="M3283 2873 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
    <path d="M3522 2873 l168 -3 3 -548 2 -547 0 550 0 550 -170 0 -170 1 167 -3z"/>
    <path d="M3827 2873 c-3 -5 59 -7 136 -5 265 4 292 8 80 10 -116 1 -214 -1
-216 -5z"/>
    <path d="M6028 2873 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
    <path d="M7433 2873 c48 -2 125 -2 170 0 45 1 6 3 -88 3 -93 0 -130 -2 -82 -3z"/>
    <path d="M7978 2873 c45 -2 119 -2 165 0 45 1 8 3 -83 3 -91 0 -128 -2 -82 -3z"/>
    <path d="M10378 2873 c57 -2 147 -2 200 0 53 1 7 3 -103 3 -110 0 -154 -2 -97
-3z"/>
    <path d="M12263 2873 c48 -2 126 -2 175 0 48 1 8 3 -88 3 -96 0 -136 -2 -87
-3z"/>
    <path d="M7850 2318 c-3 -306 -2 -554 3 -549 4 4 6 254 5 557 l-3 549 -5 -557z"/>
    <path d="M12885 2850 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
    <path d="M16456 2845 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
    <path d="M18335 2800 c79 -87 82 -90 57 -55 -11 17 -42 50 -68 75 -43 40 -42
38 11 -20z"/>
    <path d="M3825 2350 c0 -278 1 -391 2 -253 2 139 2 367 0 505 -1 139 -2 26 -2
-252z"/>
    <path d="M11134 2790 c66 -74 73 -80 48 -45 -11 17 -37 46 -58 65 -31 28 -29
24 10 -20z"/>
    <path d="M15460 2820 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M15856 2825 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14
0z"/>
    <path d="M18110 2826 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z"/>
    <path d="M10910 2816 c0 -2 16 -13 36 -25 19 -12 32 -16 29 -11 -7 11 -65 43
-65 36z"/>
    <path d="M15811 2777 c-13 -21 -12 -21 5 -5 10 10 16 20 13 22 -3 3 -11 -5
-18 -17z"/>
    <path d="M17361 2766 l-24 -31 28 27 c16 15 27 29 24 31 -2 3 -15 -10 -28 -27z"/>
    <path d="M18230 2738 c24 -27 45 -48 47 -48 8 0 0 9 -44 50 l-48 45 45 -47z"/>
    <path d="M11030 2728 c24 -27 45 -48 47 -48 8 0 0 9 -44 50 l-48 45 45 -47z"/>
    <path d="M15290 2750 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M17320 2710 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M15260 2700 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M11210 2690 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M17458 2693 c-18 -21 -31 -43 -25 -43 2 0 13 14 25 30 25 33 24 41 0
13z"/>
    <path d="M14650 2680 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M15653 2660 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
    <path d="M14780 2681 c0 -5 7 -15 17 -22 15 -13 15 -12 4 9 -12 23 -21 28 -21
13z"/>
    <path d="M9450 2650 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M15340 2625 c-7 -9 -10 -18 -7 -21 3 -3 10 4 17 15 13 25 8 27 -10 6z"/>
    <path d="M8810 2610 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M9420 2600 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M12993 2565 c0 -33 2 -45 4 -27 2 18 2 45 0 60 -2 15 -4 0 -4 -33z"/>
    <path d="M18320 2615 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
    <path d="M8700 2580 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M9530 2580 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M14710 2580 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M15170 2550 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M15822 2545 c15 -16 29 -27 31 -24 3 2 -10 15 -27 28 l-31 24 27 -28z"/>
    <path d="M9375 2520 c-9 -16 -13 -30 -11 -30 3 0 12 14 21 30 9 17 13 30 11
30 -3 0 -12 -13 -21 -30z"/>
    <path d="M9500 2530 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M14740 2530 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M8890 2470 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M9340 2460 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M15725 2460 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
    <path d="M17232 2460 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
    <path d="M11293 2425 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
    <path d="M18503 2385 c0 -38 2 -53 4 -32 2 20 2 52 0 70 -2 17 -4 1 -4 -38z"/>
    <path d="M15210 2410 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M12815 2394 c-9 -15 -12 -23 -6 -20 11 7 35 46 28 46 -3 0 -12 -12
-22 -26z"/>
    <path d="M14820 2400 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M17353 2375 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"/>
    <path d="M9420 2390 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M14960 2390 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M15850 2380 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
    <path d="M14850 2350 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M11293 2325 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
    <path d="M4580 2048 c-3 -158 -2 -284 3 -279 4 4 6 133 5 287 l-3 279 -5 -287z"/>
    <path d="M8860 2310 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M14164 2050 c0 -157 2 -221 3 -142 2 78 2 206 0 285 -1 78 -3 14 -3
-143z"/>
    <path d="M17232 2290 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
    <path d="M11162 2280 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
    <path d="M16170 2290 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
    <path d="M16455 2280 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
    <path d="M8890 2260 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M9020 2250 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M12503 2263 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"/>
    <path d="M1771 2241 c-14 -14 -20 -40 -25 -122 -4 -57 -11 -158 -17 -224 -6
-66 -9 -174 -7 -240 2 -101 6 -124 23 -147 30 -40 80 -64 205 -98 174 -46 243
-76 404 -174 89 -54 116 -66 152 -66 104 0 134 41 134 180 l0 96 61 62 c33 35
59 68 56 75 -3 9 -59 13 -203 17 -192 5 -201 6 -255 32 -96 48 -129 140 -106
295 7 45 5 55 -12 72 -17 17 -32 20 -95 19 -64 -1 -79 2 -110 23 -39 27 -45
36 -77 127 -31 88 -83 118 -128 73z"/>
    <path d="M12780 2215 c-14 -8 -20 -14 -14 -15 5 0 19 7 30 15 24 18 16 19 -16
0z"/>
    <path d="M16350 2205 c13 -14 26 -25 28 -25 3 0 -5 11 -18 25 -13 14 -26 25
-28 25 -3 0 5 -11 18 -25z"/>
    <path d="M8940 2170 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
    <path d="M9290 2170 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M14954 1975 c0 -115 2 -161 3 -102 2 59 2 154 0 210 -1 56 -3 8 -3
-108z"/>
    <path d="M12538 2153 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
    <path d="M11090 2099 c-7 -11 -28 -39 -48 -62 l-36 -42 35 32 c32 31 76 93 65
93 -3 0 -10 -9 -16 -21z"/>
    <path d="M16402 2085 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
    <path d="M17447 2075 c12 -16 34 -41 49 -55 19 -17 15 -10 -10 20 -53 61 -63
71 -39 35z"/>
    <path d="M9210 2030 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M18219 2003 l-34 -38 38 34 c34 33 42 41 34 41 -2 0 -19 -17 -38 -37z"/>
    <path d="M11141 1967 c-37 -42 -42 -51 -17 -27 34 31 83 90 74 90 -2 0 -27
-28 -57 -63z"/>
    <path d="M15666 2004 c-3 -9 -2 -12 5 -9 5 4 18 1 27 -6 13 -11 12 -8 -2 9
-23 26 -22 26 -30 6z"/>
    <path d="M18336 1952 l-60 -67 53 50 c43 41 81 87 69 84 -2 0 -30 -30 -62 -67z"/>
    <path d="M9180 1980 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M17365 1980 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20
-23 20 -3 0 3 -9 13 -20z"/>
    <path d="M9065 1961 c8 -17 19 -33 25 -36 5 -3 1 10 -11 29 -25 43 -36 48 -14
7z"/>
    <path d="M2344 1967 c-3 -8 -4 -34 -2 -58 l3 -44 50 0 50 0 0 55 0 55 -48 3
c-34 2 -49 -1 -53 -11z"/>
    <path d="M2504 1967 c-3 -8 -4 -34 -2 -58 l3 -44 55 0 55 0 0 55 0 55 -53 3
c-38 2 -54 -1 -58 -11z"/>
    <path d="M2674 1967 c-3 -8 -4 -34 -2 -58 l3 -44 50 0 50 0 0 55 0 55 -48 3
c-34 2 -49 -1 -53 -11z"/>
    <path d="M16354 1959 c-10 -12 -32 -30 -49 -40 -16 -11 -24 -19 -17 -19 12 0
103 79 91 80 -3 0 -14 -10 -25 -21z"/>
    <path d="M16490 1950 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
    <path d="M17570 1956 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z"/>
    <path d="M10900 1935 c-14 -8 -20 -14 -14 -15 5 0 19 7 30 15 24 18 16 19 -16
0z"/>
    <path d="M18100 1925 c-14 -8 -20 -14 -14 -15 5 0 19 7 30 15 24 18 16 19 -16
0z"/>
    <path d="M16455 1900 c-10 -11 -16 -22 -14 -24 2 -2 12 7 22 20 22 29 17 32
-8 4z"/>
    <path d="M17485 1870 c7 -11 65 -43 65 -36 0 2 -16 13 -36 25 -19 12 -32 16
-29 11z"/>
    <path d="M17788 1873 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
    <path d="M16053 1863 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z"/>
    <path d="M15734 1836 c11 -9 24 -16 30 -16 12 0 7 5 -24 19 -24 11 -24 11 -6
-3z"/>
    <path d="M3822 1795 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
    <path d="M13480 581 c-8 -17 -7 -24 10 -41 28 -28 63 -11 58 28 -4 35 -51 44
-68 13z"/>
    <path d="M16740 333 c0 -148 4 -274 9 -281 5 -8 17 -12 27 -10 17 3 19 16 24
138 5 145 12 165 61 194 42 25 122 21 154 -7 34 -29 44 -79 45 -219 l0 -108
26 0 26 0 -4 147 c-3 127 -6 153 -23 183 -27 45 -76 69 -143 70 -56 0 -83 -9
-119 -43 l-23 -20 0 111 0 112 -30 0 -30 0 0 -267z"/>
    <path d="M17700 320 l0 -280 25 0 25 0 0 280 0 280 -25 0 -25 0 0 -280z"/>
    <path d="M12672 308 l3 -263 28 -3 27 -3 0 73 0 74 48 47 c26 26 52 47 58 47
6 0 57 -53 114 -117 82 -94 109 -118 131 -120 16 -2 29 0 29 3 0 4 -50 66
-111 138 -61 72 -113 136 -116 143 -3 6 45 63 106 125 107 110 109 113 80 116
-26 3 -46 -14 -184 -155 l-154 -158 -1 158 0 157 -30 0 -30 0 2 -262z"/>
    <path d="M14852 308 l3 -263 28 -3 27 -3 0 84 0 85 113 4 c94 3 118 7 152 26
52 30 73 60 84 118 16 87 -14 150 -92 189 -47 23 -61 25 -184 25 l-133 0 2
-262z m295 191 c46 -29 66 -71 60 -126 -9 -84 -60 -113 -202 -113 l-95 0 0
130 0 130 101 0 c86 0 107 -3 136 -21z"/>
    <path d="M13190 240 l0 -200 24 0 c23 0 23 1 28 133 3 106 8 138 23 160 21 33
64 57 100 57 20 0 25 5 25 25 0 20 -5 25 -24 25 -38 0 -77 -18 -103 -48 l-23
-27 0 38 c0 33 -3 37 -25 37 l-25 0 0 -200z"/>
    <path d="M13490 240 l0 -200 25 0 25 0 0 200 0 200 -25 0 -25 0 0 -200z"/>
    <path d="M13690 240 l0 -200 25 0 25 0 0 113 c0 182 24 227 126 235 113 9 134
-24 134 -213 l0 -135 26 0 26 0 -4 159 c-3 154 -4 160 -28 186 -43 46 -77 58
-146 52 -47 -3 -71 -11 -98 -32 l-36 -27 0 31 c0 26 -4 31 -25 31 l-25 0 0
-200z"/>
    <path d="M14234 421 c-47 -21 -61 -38 -45 -54 7 -7 22 -5 50 8 53 23 145 23
172 -1 16 -14 39 -71 39 -96 0 -5 -35 -8 -77 -8 -96 0 -143 -12 -177 -46 -33
-34 -35 -93 -5 -135 37 -53 157 -63 219 -19 36 26 40 25 40 -5 0 -20 5 -25 26
-25 l26 0 -4 152 c-3 138 -5 156 -26 190 -13 21 -36 41 -54 47 -48 17 -138 13
-184 -8z m210 -206 c19 -51 -34 -118 -102 -130 -106 -17 -170 83 -82 127 46
24 175 25 184 3z"/>
    <path d="M15404 421 c-47 -22 -56 -32 -45 -50 7 -10 21 -9 72 8 84 29 134 20
166 -28 13 -19 23 -44 23 -56 0 -21 -5 -23 -98 -27 -100 -5 -133 -15 -164 -52
-22 -26 -23 -89 -3 -120 41 -62 162 -73 230 -22 l35 27 0 -31 c0 -27 3 -31 23
-28 21 3 22 7 25 136 3 158 -6 202 -51 234 -45 32 -155 37 -213 9z m214 -228
c4 -40 -20 -77 -63 -97 -94 -45 -200 24 -151 99 18 27 43 33 141 31 l70 -1 3
-32z"/>
    <path d="M15820 241 l0 -201 25 0 25 0 0 125 c0 179 28 225 139 225 42 0 56
-5 83 -29 l33 -29 3 -146 4 -146 24 0 24 0 0 143 c0 160 -10 193 -70 235 -57
38 -180 26 -220 -23 -14 -17 -15 -16 -20 11 -4 20 -12 30 -28 32 l-22 3 0
-200z"/>
    <path d="M16391 418 c-63 -31 -101 -94 -101 -169 0 -73 12 -105 58 -152 58
-59 150 -74 228 -36 58 27 72 45 52 65 -13 14 -19 13 -53 -10 -46 -31 -118
-35 -164 -9 -65 38 -90 137 -52 211 43 83 160 104 228 40 22 -20 25 -21 40 -5
16 15 15 18 -1 36 -49 54 -158 67 -235 29z"/>
    <path d="M17296 424 c-59 -21 -71 -34 -51 -53 12 -12 19 -13 34 -4 38 24 100
34 139 23 48 -12 71 -37 79 -84 l6 -36 -74 0 c-103 -1 -149 -13 -181 -50 -39
-42 -38 -88 2 -134 22 -24 43 -36 71 -41 60 -10 121 2 152 31 l27 25 0 -31 c0
-25 4 -30 25 -30 l25 0 0 151 c0 171 -10 202 -74 233 -41 20 -127 20 -180 0z
m204 -235 c0 -33 -6 -47 -30 -69 -46 -43 -141 -51 -176 -15 -35 35 -20 103 26
116 14 4 60 7 103 8 l77 1 0 -41z"/>
  </g>
    </svg>
  );
}
